import { createAxios, createAxiosHeaders } from "./axiosHttpMarconi";

function getEnviosAgrupados(pagination, filters) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `cliente/${user.extraData.clienteId}/envios-agrupados`;

  if (pagination) {
    urlPath += `?page=${pagination.currentPage - 1}&limit=${
      pagination.perPage
    }`;
  } else {
    urlPath += "?page=0&limit=10";
  }

  urlPath += getFilters(filters);

  return axios.get(urlPath);
}

function getEnviosAgrupadosExcel(filters) {
  const axios = createAxiosHeaders();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `cliente/${user.extraData.clienteId}/envios-agrupados/excel?limit=2000`;

  urlPath += getFilters(filters);
  return axios.get(urlPath, { responseType: "blob" }).then((response) => {
    const contentDisposition = response.headers["content-disposition"];
    const fileName = contentDisposition;
    return Promise.resolve({ blob: response.data, fileName: fileName });
  });
}
function imprimirEtiquetas(id, bultos) {
  const axios = createAxios();
  let urlPath = `envios-agrupados/${id}/etiquetas`;
  if (bultos) {
    urlPath += `?bultos=${bultos}`;
  }
  return axios.get(urlPath, { responseType: "blob" });
}
function finalizar(body) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  const urlPath = `cliente/${user.extraData.clienteId}/envios-agrupados/finalizar`;
  return axios.post(urlPath, body);
}

function anular(id) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  const urlPath = `cliente/${user.extraData.clienteId}/envios-agrupados/${id}/anular`;
  return axios.put(urlPath);
}
function editar(id, body) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  const urlPath = `cliente/${user.extraData.clienteId}/envios-agrupados/${id}`;
  return axios.put(urlPath, body);
}

function getById(id) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  const urlPath = `cliente/${user.extraData.clienteId}/envios-agrupados/${id}`;
  return axios.get(urlPath);
}

function getFilters(filters) {
  let urlPath = "";
  if (filters && filters.servicios) {
    urlPath += `&servicios=${filters.servicios.join()}`;
  }

  if (filters && filters.estados) {
    urlPath += `&estados=${filters.estados.join()}`;
  }

  if (filters && filters.sort) {
    urlPath += `&sort=${filters.sort.prop}&order=${filters.sort.order}`;
  }

  if (filters && filters.referencia) {
    urlPath += `&referencia=${filters.referencia}`;
  }

  if (filters && filters.referencia2) {
    urlPath += `&referencia2=${filters.referencia2}`;
  }

  if (filters && filters.destinatario) {
    urlPath += `&destinatario=${filters.destinatario}`;
  }

  if (filters && filters.cp_destino) {
    urlPath += `&cp_destino=${filters.cp_destino}`;
  }
  return urlPath;
}

export const enviosAgrupadosService = {
  getEnviosAgrupados,
  imprimirEtiquetas,
  finalizar,
  anular,
  getById,
  editar,
  getEnviosAgrupadosExcel,
};
